import styled, { css } from 'styled-components';
import { mediaBreakpointUp } from 'utils/styledCssHelpers';

// Example of use. Delete if not needed.
export const SCard = styled.div`
  word-wrap: break-word;
  border-radius: 8px;
  background: #fff;
  box-shadow: ${props => props.theme.shadow};
  margin-bottom: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;

  ${props =>
    props.fullCardLink
      ? `
    &:hover {
      background-color: ${props.theme.colors.primary_transparent};
      transition: background-color 0.5s;
      cursor: pointer;
    }
  `
      : ``}
`;

export const SCardBody = styled.div`
  min-height: 1px;
  padding: 30px;
  flex: 1 1 auto;
`;

export const SCardFooter = styled.div`
  padding: 0 30px 30px 30px;

  span {
    color: ${props => props.theme.colors.primary};
  }
`;

export const SCardTitle = styled.div`
  margin-bottom: 0.75rem;
  font-weight: 600;
  font-size: 20px;
  color: ${props => props.theme.colors.main};
  ${props =>
    !props.isTextCentered
      ? css`
          display: flex;
          justify-content: space-between;
        `
      : css`
          display: block;
        `}
  ${mediaBreakpointUp('md', `min-height: 4rem;`)}
  
  div.header-icon {
    margin-left: 10px;
  }
`;

const textStyle = css`
  font-size: 16px;
  line-height: 1.5em;
  color: ${props => props.theme.colors.secondary};
`;
export const SCardText = styled.div`
  ${textStyle}

  div p {
    ${textStyle}
  }
`;

export const SFeaturePrice = styled.div`
  margin-bottom: 0.75rem;
  /* font-weight: 600; */
  font-size: 14px;
  color: ${props => props.theme.colors.primary};
`;
